// @flow
import Billboard from 'components/billboard/Billboard';
import { connect } from 'react-redux';

import { fetchHome } from 'actions/homeActions';
import { fetchArticlesStaticCategories } from 'actions/newsletterActions';
import { fetchRencontreArticle } from 'actions/rencontreActions';
import type { DispatchType, StateType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/billboard/Billboard';

const mapStateToProps = (state: StateType): StateProps => ({
  status: state.newsletterState.status,
  banniere: state.settingsState.banniere,
  title: state.settingsState.title,
  description: state.settingsState.description,
  meta_title_home: state.settingsState.meta_title_home,
  meta_description_home: state.settingsState.meta_description_home,
  clubName: state.settingsState.structure,
  prochaine_rencontre: state.settingsState.prochaine_rencontre,
  prochaine_rencontre_lien: state.settingsState.prochaine_rencontre_lien,
  prochainesRencontres: state.settingsState.prochainesRencontres,
  placeholder: state.settingsState.placeholder,
  google_verification: state.settingsState.google_verification,
  rencontresLive: state.rencontreLiveState.rencontres,
  rencontreArticle: state.rencontreState.rencontreArticle,
  home: state.homeState.home,
  homeStatus: state.homeState.status
});

const mapDispatchToProps = (dispatch: DispatchType): DispatchProps => ({
  fetchArticlesStaticCategories: () => dispatch(fetchArticlesStaticCategories()),
  fetchHome: () => dispatch(fetchHome()),
  fetchRencontreArticle: (id: string) => dispatch(fetchRencontreArticle(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(Billboard);
